import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box } from 'rebass/styled-components';

import { layout } from '../../../constants/constants';
import useFeatureToggle from '../../hooks/use-feature-toggle/useFeatureToggle';
import { FeatureToggle, IconPack, TestimonialContent } from '../../models/app-data-model';
import ShIcon from '../sh-icon/sh-icon';
import ShSlider from '../sh-slider/sh-slider';
import './testimonial-slider.scss';

export type TestimonialSliderProps = {
  testimonials: TestimonialContent[];
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
};

const TestimonialSlider: React.FC<TestimonialSliderProps> = ({ testimonials, featureToggles, iconPack }: TestimonialSliderProps) => {
  const showComponent: boolean = useFeatureToggle('testimonial-component', featureToggles);

  if (!showComponent) {
    return null;
  }

  const testimonialsRendering = testimonials.map((item, index) => {
    return (
      <div key={`testimonial-${index}-${item.consumer_name}`} className="testimonial-wrapper">
        <Box marginX={'auto'} width={layout.singleColWidth} className="testimonial">
          <ShIcon iconPack={iconPack} iconName="quote_left" className="testimonial-quote-icon" />
          <p className="testimonial-quote">{item.quote}</p>
          <div className="testimonial-footer">
            {item.consumer_image?.file?.localAsset?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                className="testimonial-img-container"
                imgClassName="testimonial-img"
                image={item.consumer_image?.file?.localAsset?.childImageSharp?.gatsbyImageData}
                alt={item.consumer_image?.alt_text}
                data-testid="testimonial-img"
              />
            )}
            <div className="testimonial-consumer">
              <span className="consumer-name">{item.consumer_name}</span>
              {item.consumer_description && (
                <span className="consumer-desc" data-testid="consumer-desc">
                  , {item.consumer_description}
                </span>
              )}
            </div>
          </div>
        </Box>
      </div>
    );
  });

  return (
    <>
      {testimonials.length > 1 ? (
        <ShSlider numberOfCards={testimonials.length} hideBackground={true} iconPack={iconPack}>
          <div className="testimonial-slider">{testimonialsRendering}</div>
        </ShSlider>
      ) : (
        <div className="testimonial-slider">{testimonialsRendering}</div>
      )}
    </>
  );
};

export default TestimonialSlider;
